import {
  FormSGUpdate,
  ParamsUrl,
} from '@domain/interfaces';
import { TypeOfDamage } from '@domain/interfaces';
import {
  ATTRIBUTE_FROM_URL_SET,
  CCS_INFORMATION_UUID_SET,
  DAMAGE_TYPE_UPDATE,
  FORM_SG_UPDATE,
  INSURANCE_INFORMATION_ID_SET,
  LICENSEPLATE_UUID_SET,
  VEHICLE_IDENTIFICATION_ID_SET,
  VEHICLE_INFO_SET
} from '../shared/action-names';
import { caseDetailActionTypes } from './types';

export function damageTypeUpdate(
  damageType: TypeOfDamage,
): caseDetailActionTypes {
  return { type: DAMAGE_TYPE_UPDATE, payload: damageType };
}

export function formUpdateSG(
  dataToUpdate: FormSGUpdate,
): caseDetailActionTypes {
  return { type: FORM_SG_UPDATE, payload: dataToUpdate };
}

export function attributesFromUrlSet(params: ParamsUrl): caseDetailActionTypes {
  return { type: ATTRIBUTE_FROM_URL_SET, payload: params };
}

export function vehicleIdentificationIDSet(
  vehicleIdentificationID: string,
): caseDetailActionTypes {
  return {
    type: VEHICLE_IDENTIFICATION_ID_SET,
    payload: vehicleIdentificationID,
  };
}

export function vehicleInfoSet(vehicleInfo: {vehicleModelName:string, vehicleManufacturerName: string}): caseDetailActionTypes {
 return {
    type: VEHICLE_INFO_SET,
    payload: vehicleInfo,
  };
}

export function ccsInformationUUIDSet(
  cCSInformationUUID: string,
): caseDetailActionTypes {
  return {
    type: CCS_INFORMATION_UUID_SET,
    payload: cCSInformationUUID,
  };
}

export function insuranceInformationIDSet(
  insuranceInformationID: string,
): caseDetailActionTypes {
  return {
    type: INSURANCE_INFORMATION_ID_SET,
    payload: insuranceInformationID,
  };
}

export function licensePlateUUIDSet(
  licensePlateUUID: string,
): caseDetailActionTypes {
  return {
    type: LICENSEPLATE_UUID_SET,
    payload: licensePlateUUID,
  };
}